import React from "react";
import { useFormContext } from "react-hook-form";
import {
    ContentSection,
    FormCheckbox,
    FormDropdown,
    FormFields,
    FormNumberTextField,
    FormTextField,
    NamedProperty,
    mapToDropdownOption
} from "sprint-common-web";

import { validateDuration } from "../../../common/utils/validateDuration";
import { validateResolution } from "../../../common/utils/validateResolution";
import { useCreateFileRecordFormOptions } from "../hooks/useCreateFileRecordFormOptions";

export const CreateVideoFileRecordTechInfoForm: React.FC = () => {
    const { areOptionsLoading, aspectRatios, aspectTypes, standards } = useCreateFileRecordFormOptions();
    const { errors, control } = useFormContext();

    const getDropdownOptions = (dataEntries: NamedProperty[]) =>
        dataEntries.map((dataEntry) => mapToDropdownOption(dataEntry));

    return (
        <ContentSection header="Technical" isLoading={areOptionsLoading} style={{ minHeight: "80vh" }}>
            <FormFields>
                <FormDropdown
                    options={getDropdownOptions(aspectRatios)}
                    label="Aspect ratio"
                    name={"videoAspectRatio"}
                    control={control}
                    errors={errors}
                />
                <FormDropdown
                    options={getDropdownOptions(aspectTypes)}
                    label="Aspect type"
                    name={"videoAspectType"}
                    control={control}
                    errors={errors}
                />
                <FormCheckbox label="Encoding (Proresolution)" name={"videoEncoding"} control={control} />
                <FormTextField label="Framerate" name={"videoFramerate"} control={control} errors={errors} />
                <FormNumberTextField label="Bitrate" name={"videoBitrate"} control={control} errors={errors} />
                <FormTextField
                    rules={{ validate: validateDuration }}
                    label="Duration"
                    name={"videoDuration"}
                    control={control}
                    errors={errors}
                    mask="99:99:99"
                />
                <FormTextField
                    label="Resolution"
                    name={"videoResolution"}
                    control={control}
                    errors={errors}
                    rules={{
                        validate: validateResolution
                    }}
                />
                <FormDropdown
                    options={getDropdownOptions(standards)}
                    label="Standard"
                    name={"videoStandard"}
                    control={control}
                    errors={errors}
                />
            </FormFields>
        </ContentSection>
    );
};
